const amenitiesSections = [
  {
    section: "Room View",
    key: "room_view",
    options: [
      "Park", "Ocean", "Garden", "Pool", "City", "Mountain", "Lake", "River", "Beach", "Lagoon", "Harbor", "Ocean (partial view)", "Sea", "Sea (partial view)", "Country", "Lake (partial view)", "Nature", "Street", "Courtyard", "No Windows", "Gulf", "Marina", "Bay", "Valley", "Night", "Countryside"
    ]
  },
  {
    section: "Bathroom and toiletries",
    key: "bathroom",
    options: [
      "Bathrobes", "Bathtub", "Shower", "Separate shower/bathtub", "Whirlpool bathtub", "Shared bathroom", "Toiletries", "Additional toilet", "Mirror", "TV [in bathroom]", "Adapted bath", "Walk-in shower", "Shower chair", "Accessible toilet", "Hair dryer", "Additional bathroom", "Bathroom phone", "Cleaning products", "Scale", "Towels", "Private bathroom", "Open air bath privileges"
    ]
  },
  {
    section: "Entertainment",
    key: "entertainment",
    options: [
      "On-demand movies", "Internet access – wireless", "Internet access – LAN", "TV", "TV [flat screen]", "Satellite/cable channels", "DVD/CD player", "Video game console", "Wi-Fi [free]", "LAN Internet in room [free]", "Telephone", "iPod docking station", "In-room tablet", "Streaming service like Netflix", "Pool facilities", "Radio", "Sauna", "Computer", "Blu-ray player", "Board games/puzzles", "Books/DVDs/music for children", "Mobile hotspot device", "Smartphone device", "Reading light", "Complimentary spa access", "Free use of business areas", "Private beach access", "Wi-Fi [charges apply]", "LAN Internet in room [charges apply]", "Hot spring access", "Video streaming like Netflix (charges apply)", "Activity Kits"
    ]
  },
  {
    section: "Layout and furnishings",
    key: "layout",
    options: [
      "Desk", "Balcony/terrace", "Private pool", "Seating area", "Extra long bed", "Interconnecting room(s) available", "Carpeting", "High chair", "Fireplace", "Sofa", "Wooden/parqueted flooring", "Separate living room", "Laptop workspace", "Limited access floor", "High floor", "Top floor available", "Ground floor available", "Low floor available", "Tile/marble flooring", "Outdoor furniture", "Fold-up bed", "Trash cans", "Tatami flooring", "Window", "Separate dining area", "Window that opens", "Openable window"
    ]
  },
  {
    section: "Safety and security features",
    key: "safety",
    options: [
      "In-room safe box", "Laptop safe box", "Locker", "Smoking allowed", "Individual air conditioning", "Baby safety gates", "Accessible by stairs", "Accessible by elevator", "Non-smoking", "Smoke detector", "Carbon monoxide detector", "Safety/security feature", "Detached", "Semi-detached", "Private apartment in building"
    ]
  },
  {
    section: "Access",
    key: "access",
    options: [
      "Pets allowed in room", "Exterior corridor"
    ]
  },
  {
    section: "Comforts",
    key: "comforts",
    options: [
      "Air conditioning", "Daily newspaper", "Fan", "Executive lounge access", "Heating", "Soundproofing", "Alarm clock", "Mosquito net", "Blackout curtains", "Wake-up service", "Air purifier", "Electric blanket", "Linens", "Private entrance", "Slippers", "Umbrella", "Sleep comfort items", "Hypoallergenic", "Pajamas", "Socket near the bed", "Adapter", "Concierge", "Hand sanitizer"
    ]
  },
  {
    section: "Clothing and laundry",
    key: "clothing",
    options: [
      "Ironing facilities", "Washing machine", "Trouser press", "Clothes dryer", "Clothes rack", "Dressing room", "Sewing kit", "Shoeshine kit", "Closet", "Free laundry service"
    ]
  },
  {
    section: "Dining, drinking and snacking",
    key: "dining",
    options: [
      "Microwave", "Coffee/tea maker", "Free bottled water", "Refrigerator", "Dishwasher", "Kitchenware", "Free instant coffee", "Complimentary tea", "Full kitchen", "Fruits/snacks", "Dining table", "Alcohol", "Wine glasses", "Kettle", "Mini bar", "Kitchenette", "Free welcome drink", "Espresso machine with pods (charges apply)", "BBQ facilities", "In-room meal prep"
    ]
  },
  {
    section: "Accessibility",
    key: "accessibility",
    options: [
      "Braille and tactile signage", "Audible alarm", "Visual alarm", "Mobility accessibility", "Transfer shower", "Roll-in shower", "Adjustable height hand-held shower wand", "Bathtub seat", "Non-slip grab bar", "Lowered electrical outlet", "Flashing door knocker", "Lowered deadbolt on door", "Lever handle on door", "Hearing accessible room and/or kit", "Bathtub grab bar", "Accessible vanities", "Alarm clock telephone ringer", "Lowered view port in door", "Lowered night guard on door", "Self-closing door", "TTY/TTD compatibilty", "Close-caption TV"
    ]
  },
  {
    section: "Others",
    key: "others",
    options: [
      "Humidifier", "Bicycle rental [free]", "Swimming pool [direct access]", "Fitness club privileges", "Access through interior corridor", "View port in door", "Safety chain and/or latch on door", "Vegetarian", "Stove", "Freezer", "Kitchen basics (cookware, oils, condiments)", "Oven"
    ]
  }
];

export default amenitiesSections; 